import React from 'react';
import { MDBDataTableV5 } from 'mdbreact';

export function BasicDataTable(props) {
    return (
        <>
            <MDBDataTableV5 hover entriesOptions={[25, 50, 100]} entries={25} data={props.data} searchTop searchBottom={false}/>
        </>
    );
} 